import type { Level } from '@tiptap/extension-heading';

/**
 * The available heading levels in the editor (h1, h2, h3)
 */
export const HEADING_LEVELS: Level[] = [1, 2, 3];
